/**
 * Product Image Scroll Sync
 * Cambia la imagen principal del producto según el scroll sobre las miniaturas
 */

(function () {
  'use strict';

  const CONFIG = {
    gallerySelector: '.pg',
    thumbnailSelector: '.pg__thumb',
    thumbnailListSelector: '.pg__thumbs-list',
    slideSelector: '.pg__slide',
    slidesContainerSelector: '.pg__slides-container',
    viewportReference: 0.35, // 35% desde arriba del viewport
    scrollDebounceDelay: 50,
    activeClass: 'is-active',
    transitionDuration: 300,
  };

  let scrollTimeout;
  let thumbnails = [];
  let slides = [];
  let thumbnailList = null;
  let slidesContainer = null;
  let isInitialized = false;
  let isTransitioning = false;
  let lastScrollY = 0;
  let scrollDirection = 0;

  function init() {
    if (isInitialized) return;

    const gallery = document.querySelector(CONFIG.gallerySelector);
    if (!gallery) return;

    thumbnailList = gallery.querySelector(CONFIG.thumbnailListSelector);
    slidesContainer = gallery.querySelector(CONFIG.slidesContainerSelector);

    const thumbnailElements = Array.from(gallery.querySelectorAll(CONFIG.thumbnailSelector));
    const slideElements = Array.from(gallery.querySelectorAll(CONFIG.slideSelector));

    if (!thumbnailList || !slidesContainer || !thumbnailElements.length || !slideElements.length) return;

    thumbnails = thumbnailElements.map((thumb, index) => ({
      element: thumb,
      button: thumb.querySelector('.pg__thumb-btn'),
      index,
      isActive: thumb.classList.contains(CONFIG.activeClass),
    }));

    slides = slideElements.map((slide, index) => ({
      element: slide,
      index,
      isActive: slide.classList.contains(CONFIG.activeClass),
    }));

    if (window.innerWidth <= 1023) return;

    window.addEventListener('scroll', handleScroll, { passive: true });

    thumbnails.forEach((thumb) => {
      if (thumb.button) {
        thumb.button.addEventListener('click', () => {
          const index = parseInt(thumb.button.getAttribute('data-index'), 10);
          if (!isNaN(index)) activateSlide(index, true);
        });
      }
    });

    const activeThumbIndex = thumbnails.findIndex((t) => t.isActive);
    if (activeThumbIndex >= 0) activateSlide(activeThumbIndex, false);

    isInitialized = true;
  }

  function handleScroll() {
    const currentScrollY = window.scrollY || window.pageYOffset;
    scrollDirection = currentScrollY > lastScrollY ? 1 : currentScrollY < lastScrollY ? -1 : 0;
    lastScrollY = currentScrollY;

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveImage, CONFIG.scrollDebounceDelay);
  }

  function updateActiveImage() {
    if (!thumbnailList || !thumbnails.length) return;

    const currentActiveIndex = thumbnails.findIndex((t) => t.isActive);
    const referencePoint = window.innerHeight * CONFIG.viewportReference;

    if (scrollDirection > 0 && currentActiveIndex < thumbnails.length - 1) {
      const nextThumb = thumbnails[currentActiveIndex + 1];
      const rect = nextThumb.element.getBoundingClientRect();
      if (rect.top <= referencePoint) activateSlide(nextThumb.index, true);
    } else if (scrollDirection < 0 && currentActiveIndex > 0) {
      const prevThumb = thumbnails[currentActiveIndex - 1];
      const rect = prevThumb.element.getBoundingClientRect();
      if (rect.bottom >= referencePoint) activateSlide(prevThumb.index, true);
    } else if (currentActiveIndex === -1) {
      let closestThumb = null;
      let minDistance = Infinity;

      thumbnails.forEach((thumb) => {
        const rect = thumb.element.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - referencePoint);
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible && distance < minDistance) {
          minDistance = distance;
          closestThumb = thumb;
        }
      });

      if (closestThumb) activateSlide(closestThumb.index, true);
    }
  }

  function activateSlide(index, withTransition = true) {
    if (isTransitioning || index < 0 || index >= slides.length) return;

    const targetSlide = slides[index];
    const targetThumb = thumbnails[index];
    if (!targetSlide || !targetThumb || targetSlide.isActive) return;

    isTransitioning = true;

    thumbnails.forEach((thumb) => {
      thumb.isActive = false;
      thumb.element.classList.remove(CONFIG.activeClass);
      if (thumb.button) thumb.button.setAttribute('aria-selected', 'false');
    });

    slides.forEach((slide) => {
      slide.isActive = false;
      slide.element.classList.remove(CONFIG.activeClass);
    });

    targetSlide.isActive = true;
    targetSlide.element.classList.add(CONFIG.activeClass);
    targetThumb.isActive = true;
    targetThumb.element.classList.add(CONFIG.activeClass);
    if (targetThumb.button) targetThumb.button.setAttribute('aria-selected', 'true');

    if (slidesContainer) {
      slidesContainer.style.transition = withTransition
        ? `transform ${CONFIG.transitionDuration}ms ease-in-out`
        : 'none';
      slidesContainer.style.transform = `translateX(-${index * 100}%)`;
    }

    document.dispatchEvent(
      new CustomEvent('productImageChanged', {
        detail: { index, slideElement: targetSlide.element, thumbElement: targetThumb.element },
      }),
    );

    setTimeout(() => (isTransitioning = false), CONFIG.transitionDuration);
  }

  function destroy() {
    if (!isInitialized) return;
    window.removeEventListener('scroll', handleScroll);
    clearTimeout(scrollTimeout);
    thumbnails = [];
    slides = [];
    thumbnailList = null;
    slidesContainer = null;
    isInitialized = false;
  }

  function reinit() {
    destroy();
    setTimeout(init, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', reinit);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth > 1023 && !isInitialized) {
        init();
      } else if (window.innerWidth <= 1023 && isInitialized) {
        destroy();
      }
    }, 250);
  });

  window.ProductImageScrollSync = { init, destroy, reinit, updateActiveImage };
})();
